import React from 'react';
import { Crisp } from 'crisp-sdk-web';
import { Building2 } from 'lucide-react';
import { C } from '../../styles/tokens';

export default function EnterpriseStrip() {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 14, padding: '16px 20px',
        background: C.n50, border: '1px solid ' + C.n200, borderRadius: 13, marginBottom: 26,
      }}
    >
      <div
        style={{
          width: 38, height: 38, borderRadius: 10, background: C.w, border: '1px solid ' + C.n200,
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <Building2 size={17} color={C.n900} strokeWidth={1.8} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 700, color: C.n900 }}>Looking for a custom Enterprise plan?</div>
        <div style={{ fontSize: 12, color: C.n500, marginTop: 2 }}>Volume pricing, custom integrations, and dedicated support for large teams.</div>
      </div>
      <button
        type="button"
        onClick={() => Crisp.chat.open()}
        style={{
          padding: '9px 16px', background: C.n900, color: C.w, border: 'none', borderRadius: 9,
          fontSize: 12.5, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
        }}
      >
        Talk to us
      </button>
    </div>
  );
}
